import { Component, OnInit } from '@angular/core';
import { CommonService } from '../common.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss'],
  host: {
    class: 'center-route-content'
  }  
})
export class PrivacyComponent implements OnInit {
  title: string = "b2c.IDS_PRIVACY";
  subtitle: string = "b2c.IDS_PRIVACY_SUB";
  question: string = "b2c.IDS_PRIVACY_QUE";
  activePage: string = "privacy";
  nextPage: string = "summary";

  constructor(
    private ar: ActivatedRoute,
    private ro: Router,        
    private cs: CommonService
  ) { 
    this.cs.setParams(this.title, this.subtitle, this.question, this.activePage, this.nextPage, false, false, false, true, null, false);
  }

  ngOnInit() {
  }

  closeBtnClick(){
    this.ro.navigate(["/wiz/summary"], {});
  }

}
